( function() {
	const stickyBar = document.querySelector( '.facility-details__sticky' );
	if( !stickyBar ) { return; }

	const inPageBtns = document.querySelector( '.facility-details__overview-btns' );
	const ACTIVE = 'facility-details__sticky--active'; // sticky behavior
	const UNSTUCK = 'facility-details__sticky--unstuck'; // buttons are in view
	const IN_PAGE = 'facility-details__sticky--in-page'; // scrolling with the page, either naturally because of sticky behavior or because it's supressed with UNSTUCK

	const buttonObserver = new IntersectionObserver( function( entries ) {
		entries.forEach( function( entry ) {
			if( entry.target === inPageBtns ) {
				if( entry.isIntersecting ) { // contact info in view
					stickyBar.classList.add( UNSTUCK, IN_PAGE );
					stickyBar.classList.remove( ACTIVE );
				} else {
					stickyBar.classList.add( ACTIVE );
					stickyBar.classList.remove( UNSTUCK, IN_PAGE );
				}
				document.body.dispatchEvent( new Event( 'facility-detail-sticky-changed' ) );
			}
		} );
	}, { threshold: .5 } ); // when 50% of it is visible
	buttonObserver.observe( inPageBtns );


	const barObserver = new IntersectionObserver( function( entries ) {
		entries.forEach( function( entry ) {
			if( entry.target === stickyBar ) {
				if( entry.isIntersecting ) {
					stickyBar.classList.add( IN_PAGE );
				} else if( !stickyBar.classList.contains( UNSTUCK ) ) {
					stickyBar.classList.remove( IN_PAGE );
				}
			}
		} );
	}, { threshold: 1 } ); // when 100% of it is visible (i.e. it is now scrolling with the page, as it's normally bottom: -1 when sticky)

	barObserver.observe( stickyBar );
} )();